// Features icons
import globe_icon from "@/assets/icons/device/globe-alt.svg";
import map_pin_icon from "@/assets/icons/device/map-pin.svg";
import remote_control_icon from "@/assets/icons/device/remote-control.svg";
import shield_check_icon from "@/assets/icons/device/shield-check.svg";
import wrench_icon from "@/assets/icons/device/wrench.svg";

// Review Avatars
import avatar_1_url from "@/assets/images/productCard/reviews/avatar_1.png";
import avatar_2_url from "@/assets/images/productCard/reviews/avatar_2.png";
import avatar_3_url from "@/assets/images/productCard/reviews/avatar_3.png";

// Additional info icons
import calendar_iconUrl from "@/assets/icons/productDetails/calendar-days.svg";
import cube_iconUrl from "@/assets/icons/productDetails/cube.svg";

export const additionalInfo = [
  {
    iconUrl: cube_iconUrl,
    title: "Enjoy free standard shipping and returns",
  },
  {
    iconUrl: calendar_iconUrl,
    title: "Lifetime Warranty",
    text: "Your assurance of quality",
  },
];

export const specificationDescription = [
  {
    title: "Compatibility",
    data: [
      "Compatible with a wide range of vehicle types including cars, trucks, vans, and motorcycles.",
      "Supports integration with vehicles' onboard diagnostic (OBD) systems for enhanced monitoring and diagnostics.",
    ],
  },
  {
    title: "Installation",
    data: [
      "Easy installation with simple wiring and mounting options.",
      "Plug-and-play options available for quick setup and deployment.",
    ],
  },
  {
    title: "Maintenance and Support",
    data: [
      "Low maintenance requirements with periodic software updates available over-the-air (OTA).",
      "Dedicated customer support for troubleshooting and assistance.",
    ],
  },
];

export const features = {
  description:
    "Explore the technical specifications providing essential details such as dimensions, weight, power supply, GPS accuracy, communication protocols, temperature ranges, waterproof rating, shock and vibration resistance, and backup battery capacity.",
  characteristics: [
    { iconUrl: globe_icon, label: "Geo-fencing" },
    { iconUrl: remote_control_icon, label: "Remote Vehicle Control" },
    { iconUrl: map_pin_icon, label: "Integration Options" },
    {
      iconUrl: wrench_icon,
      label: "Data Logging",
    },
    { iconUrl: shield_check_icon, label: "Backup Battery" },
  ],
};

export const reviews = [
  {
    avatarUrl: avatar_1_url,
    name: "Kristin Cooper",
    date: "July 12,  2023",
    review: `As a small business owner, keeping track of my company vehicles has never been easier thanks to this tracker. The shock and vibration resistance ensure durability on rough roads, and the backup battery capacity means I never lose sight of my assets, even in emergencies. 5 stars!"
"I can't say enough good things about this product!`,
    rating: 5,
  },
  {
    avatarUrl: avatar_2_url,
    name: "Marvin Black",
    date: "September 1, 2023",
    review:
      "I've been using this vehicle tracker for months now, and it's been a game-changer for my fleet management needs. The accuracy of the GPS tracking is unparalleled, and the waterproof rating gives me peace of mind during all weather conditions. Highly recommend!",
    rating: 5,
  },
  {
    avatarUrl: avatar_3_url,
    name: "Juanita Flores",
    date: "October 11, 2022",
    review: `I can't say enough good things about this product! The communication protocols make it a breeze to integrate with my existing systems, and the operating temperature range means it performs reliably in any climate. A must-have for anyone serious about fleet management.`,
    rating: 5,
  },
  {
    avatarUrl: avatar_1_url,
    name: "Kristin Smith",
    date: "June 03,  2022",
    review: `As a small business owner, keeping track of my company vehicles has never been easier thanks to this tracker. The shock and vibration resistance ensure durability on rough roads, and the backup battery capacity means I never lose sight of my assets, even in emergencies. 5 stars!"
"I can't say enough good things about this product!`,
    rating: 5,
  },
];
